import { format } from '@office-start/string-formatter-utility';
import { useMemo } from 'react';
var USER_PROFILE_VERSION = '1';
var USER_PROFILE_METRICS_VERSION_FORMAT = 'User_Profile.Metrics.v{0}';
export var useUserProfileMetricsKey = function () {
    return useMemo(function () {
        return format(USER_PROFILE_METRICS_VERSION_FORMAT, USER_PROFILE_VERSION);
    }, []);
};
//# sourceMappingURL=useUserProfileMetricsKey.js.map